// users/{uid} の表示関連フィールドをリアルタイム購読するフック（S-061-4 / 設計doc §3-1）。
//
// dashboardLens（レンズSSOT）と industry（初期値導出用）を返す。
//
// 設計メモ:
//   - usePlan（課金安全フック）への相乗りはしない。usePlan は「読取失敗は free に倒す」という
//     課金事故防止の責務を持つため、レンズという別責務を混ぜない（責務分離 = 設計doc §3-1）。
//   - 取得前は loading=true。ルートページはこの loading が解けるまでマウントしない
//     （lens 解決前のチラつき・直列二重 read を構造的に排除する）。
//   - ドキュメント未存在・フィールド欠損・読取エラーはいずれも null/undefined に倒す
//     → resolveDashboardLens 側で 'focus'（既存ユーザー無風）にフォールバックする。
import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from './firebase';

export interface UserDocState {
  dashboardLens: string | null;
  industry: string | null;
  loading: boolean;
}

export function useUserDoc(uid: string | null | undefined): UserDocState {
  const [dashboardLens, setDashboardLens] = useState<string | null>(null);
  const [industry, setIndustry] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!uid) {
      setDashboardLens(null);
      setIndustry(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    const ref = doc(db, 'users', uid);
    const unsubscribe = onSnapshot(
      ref,
      (snap) => {
        const data = snap.exists() ? (snap.data() as any) : {};
        setDashboardLens(typeof data.dashboardLens === 'string' ? data.dashboardLens : null);
        setIndustry(typeof data.industry === 'string' ? data.industry : null);
        setLoading(false);
      },
      (e: any) => {
        console.error('[useUserDoc] failed to read user doc, falling back to focus lens:', e);
        setDashboardLens(null);
        setIndustry(null);
        setLoading(false);
      }
    );
    return unsubscribe;
  }, [uid]);

  return { dashboardLens, industry, loading };
}
